import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { BILLING_LOGS } from "./apiRoutes";

interface UseGetBillingLHistoryLogsProps {
  data: any;
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getBillingHistoryLogs = async (communityId: string, data: any) =>
  await axiosAuth.post(`${BILLING_LOGS(communityId)}/history/grid`, data);

const useGetBillingHistoryLogs = ({
  data,
  communityId,
  queryParams,
}: UseGetBillingLHistoryLogsProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["billing-history-logs"],
    queryFn: () => getBillingHistoryLogs(communityId, data),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && (queryParams?.enabled ?? true),
  });
};

export default useGetBillingHistoryLogs;
